//core
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
// import withStyles from "@material-ui/core/styles/withStyles";
//material-ui
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
//material-ui/icon
// import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
// import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
// import DoneIcon from '@material-ui/icons/Done';
// import CheckBoxIcon from '@material-ui/icons/CheckBox';
// import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
// import StopIcon from '@material-ui/icons/Stop';
// import ExtensionIcon from '@material-ui/icons/Extension';
// import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
// import FolderIcon from '@material-ui/icons/Folder';
// import FolderOpenIcon from '@material-ui/icons/FolderOpen';
// import Tooltip from '@material-ui/core/Tooltip';
// import ReactTable from "react-table";
//dashboard-pro
import Button from "components/CustomButtons/Button.jsx";
import NavPills from 'components/CompanyNavPills/NavPills.jsx';
//components
// import CheckboxTree from 'react-checkbox-tree';
// import PerfectScrollbar from "perfect-scrollbar";
//business
import CommonHttp from "global/CommonHttp";
// import {GRID_CELL_WIDTH,LongTextCell} from "businessComponents/config";
// import { GlobalContext } from 'businessComponents/Global/Global.context.js';
//css
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";
import { infoColor } from "assets/jss/material-dashboard-pro-react.jsx";


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const costDetailModalStyle = makeStyles(theme => ({
  ...modalStyle,
  modal: {
    [theme.breakpoints.down("lg")]: {
      maxWidth: "600px",
      margin: "auto"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "900px",
      margin: "auto"
    },
  },
  customIcon:{color:infoColor[0]},
  customLeafIcon:{color:infoColor[3]}
}))

function CompanyareaModal(props){
    const classes = costDetailModalStyle();

    const [showModal, setShowModal] = useState(false);
    // const [selectedName, setselectedName] = useState('');
    const [activeTab, setactiveTab] = useState(0);

    const [tabs, settabs] = useState([{
        tabButton: "省份",
        tabContent:''
    },{
        tabButton: "城市",
        tabContent:''
    },{
        tabButton: "地区",
        tabContent:''
    }])

    const handleChange = (event, active) => {
        setactiveTab(active);
    }
    let tempName;
    const openModal = () => {
        CommonHttp.get('/areas/province').then(res => {
            let content = (
                res.map((prop,index) => {
                    return <Button key={index} size='sm' color='info' onClick={() => {selectProvice(prop.name,prop.id,true)}}>{prop.name}</Button>
                })
            )
            let tab = tabs.concat();
            tab[0].tabContent = content;
            settabs(tab);
            if (props.selectedNode && props.selectedNodeText) {//这两项有数据说明已经有选择了
                let selectArea = props.selectedNodeText.split('-');
                let targetArea = res.find(el => {
                    return el.name === selectArea[0];
                })
                selectProvice(targetArea.name,targetArea.id,false,true);
            }else{
                setShowModal(true);
            }
        },err => {
            props.openSnackbar(err);
        })
    }

    const selectProvice = (name,id,manual,isInit=false) => {
        //选择省份，直接给tempName赋值，相当于重置效果
        tempName = name;
        CommonHttp.get('/areas/city?province=' + id).then(res => {
            if(Array.isArray(res) && res.length===0){
                if(isInit){
                    setactiveTab(0)
                    setShowModal(true);
                    return 
                }else{
                    props.selectArea(tempName,id);
                    setShowModal(false);
                    return
                }
            }
            let tab = tabs.concat();
            tab[1].tabContent = (
                <React.Fragment>
                    {res.map((prop,index) => {
                        return <Button key={index} size='sm' color='info' onClick={() => {selectCity(prop.name,prop.id,true)}}>{prop.name}</Button>
                    })}
                </React.Fragment>
            )
            //选择省份之后把地区区域内容清空，避免直接选择地区出现bug
            tab[2].tabContent = (
                <div style={{marginTop:'20px'}}>
                    <Button className='area-btn' size='sm' color='white' disabled>暂无数据</Button>
                </div>
            );
            if (!manual && (props.selectedNode && props.selectedNodeText)) {
                let selectArea = props.selectedNodeText.split('-');
                let targetArea = res.find(el => {
                    return el.name === selectArea[1];
                })
                selectCity(targetArea.name,targetArea.id);
            } 
            
            settabs(tab);
            setactiveTab(1);
        },err => {
            props.openSnackbar(err);
        })
    }

    const selectCity = (name,id,manual) => {
        //选择city，说明已经有省份了
        //避免出现重复的情况，将tempName分为数组，并且只取第一个来拼接
        tempName = tempName.split('-')[0] + '-' + name;
        CommonHttp.get('/areas/country?city=' + id).then(res => {
            let tab = tabs.concat();
            tab[2].tabContent = (
                <React.Fragment>
                    {res.map((prop,index) => {
                        return <Button key={index} size='sm' color='info' onClick={() => {selectCountry(prop.name,prop.id)}}>{prop.name}</Button>
                    })}
                </React.Fragment>
            )
            settabs(tab);
            setactiveTab(2);
            if (!manual && (props.selectedNode && props.selectedNodeText)) {
                setShowModal(true);
            }
        },err => {
            props.openSnackbar(err);
        })
    }

    const selectCountry = (name,id) => {
        tempName = tempName + '-' + name;
        props.selectArea(tempName,id);
        setShowModal(false);
    }

    return (
        <React.Fragment>
            <Button style={{marginTop:'15px'}} size='sm' color="info" onClick={ openModal }>点击选择</Button>
            <Dialog classes={{root:classes.center,paper:classes.modal}} 
                open={showModal} transition={Transition} maxWidth='lg'
                fullWidth={true} keepMounted
                onClose={() => {setShowModal(false)}}
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description">
                <DialogTitle id="classic-modal-slide-title"disableTypography className={classes.modalHeader}>
                    <Button justIcon aria-label="Close" key="close" color="transparent"
                    className={classes.modalCloseButton}
                    onClick={() => {setShowModal(false)}}>
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle}>{props.modalTitle}</h4>
                </DialogTitle>
                <DialogContent style={{height:'calc(100vh - 400px)',overflow:'auto'}} id="tree-modal-content" className={classes.modalBody}>
                    <NavPills color="info" active={activeTab} handleChange={handleChange}
                        tabs={tabs}/>
                </DialogContent>
                {/* <DialogActions className={classes.modalFooter +" " +classes.modalFooterCenter}>
                    <Button onClick={() => {setShowModal(false)}} color="success">确定</Button>
                </DialogActions> */}
            </Dialog>
        </React.Fragment>
    )
}

export default CompanyareaModal;